import React from 'react';
import { markdownToHtml } from '../utils/markdownParser';

interface ArticleContentProps {
  content: string;
  className?: string;
}

/**
 * Renders article content from Markdown
 * 
 * Supported syntax:
 * - Markdown: # headings, **bold**, *italic*, ~~underline~~, {color}, lists, [links](url)
 * - YouTube embeds: {youtube}VIDEO_ID{/youtube}
 * 
 * Simple, readable, no auto-detection.
 */
export const ArticleContent: React.FC<ArticleContentProps> = ({ content, className = '' }) => {
  
  const processContent = (rawContent: string): string => {
    // Step 1: Convert {youtube}ID{/youtube} to HTML iframe
    let processed = rawContent.replace(
      /\{youtube\}([a-zA-Z0-9_-]+)\{\/youtube\}/g,
      (_, videoId) => `\n\n<div class="my-6"><div class="relative w-full" style="padding-bottom: 56.25%;"><iframe src="https://www.youtube.com/embed/${videoId}" class="absolute top-0 left-0 w-full h-full rounded-lg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="YouTube video ${videoId}"></iframe></div></div>\n\n`
    );
    
    // Step 2: Convert Markdown to HTML
    return markdownToHtml(processed);
  };

  return (
    <div 
      className={`prose prose-lg max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: processContent(content) }}
    />
  );
};

